import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-site-card',
	templateUrl: './site-card.component.html',
	styleUrl: './site-card.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class SiteCardComponent {
	@Input() site;

	public headerImages = {
		freebooksy: '../../../assets/img/features/sites/fby-tile-header.svg',
		bargainbooksy: '../../../assets/img/features/sites/bby-tile-header.svg',
		redFeatherRomance: '../../../assets/img/features/sites/rfr-tile-header.svg',
		newInBooks: '../../../assets/img/features/sites/nib-tile-header.svg',
		'audio-thicket': '../../../assets/img/features/sites/atk-tile-header.svg',
		'reader-reach': '../../../assets/img/features/sites/rrf-tile-header.svg',
		'reader-reach-amazon-ads': '../../../assets/img/features/sites/rra-tile-header.svg',
		giveaways: '../../../assets/img/features/sites/ssg-tile-header.svg',
		'hello-books': '../../../assets/img/features/sites/hlb-tile-header.png',
	};

	constructor(

	) {

	}
}
